import { render, staticRenderFns } from "./discountBox.vue?vue&type=template&id=bce5533c&scoped=true&"
import script from "./discountBox.vue?vue&type=script&lang=js&"
export * from "./discountBox.vue?vue&type=script&lang=js&"
import style0 from "./discountBox.vue?vue&type=style&index=0&id=bce5533c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce5533c",
  null
  
)

export default component.exports